import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BillingInfo } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = Pick<BillingInfo, 'taxid'>;

export const useTaxId = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query taxId {
      billingAccount {
        billingInfo {
          taxid
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['taxId'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
